import { c as _c } from "react/compiler-runtime";
import { Arrow, Button, ShoppingCart, SpreadshirtLogo, SpreadshirtProLogo } from '@sprd/sprd-component-kit/v2';
import { NavActiveState, NavItem, Header as Shell } from '@sprd/spreadshirt-shell';
import { Suspense } from 'react';
import clsx from 'clsx';
import { useAtom, useSetAtom } from 'jotai';
import { useTranslations } from 'next-intl';
import { HeaderContent } from '@/types/headerHierarchy';
import { HeaderContentPro } from '@/types/spreadshirtProHeader';
import { useCart } from '@/hooks/useCartHooks';
import { UserMenuButton } from '@/components/Header/DesktopHeader/UserMenu';
import { FavoritesPageLink } from '@/components/Header/FavoritesPageLink';
import { Link } from '@/i18n/navigation';
import { basketAtom, headerPageOverlayAtom, secondLevelOpenAtom } from '@/store/atoms';
import { isProHeaderContent } from '@/utility/headerNavigationHelpers';
import { getTotalQuantity } from '@/utility/lineItems/lineItemHelpers';
import { HeaderLinkAdapter } from '../HeaderLinkAdapter';
import { SearchWrapper } from '../SearchWrapper';
import { toExternalLinks } from '../headerContent';
export const DesktopHeader = t0 => {
  const $ = _c(71);
  const {
    content,
    items,
    active,
    resetKey,
    openOnHover,
    isDesignerPage,
    subDomain,
    sprdAccountsContext
  } = t0;
  const t = useTranslations("general");
  const {
    data: cartAndLineItemGroups,
    isFetching
  } = useCart();
  const [isOpenBasket, setOpenBasket] = useAtom(basketAtom);
  const setShowOverlay = useSetAtom(headerPageOverlayAtom);
  const setSecondLevelOpen = useSetAtom(secondLevelOpenAtom);
  let t1;
  if ($[0] !== isOpenBasket || $[1] !== setOpenBasket) {
    t1 = () => setOpenBasket(!isOpenBasket);
    $[0] = isOpenBasket;
    $[1] = setOpenBasket;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleBasket = t1;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let totalQuantity;
  if ($[3] !== cartAndLineItemGroups?.lineItemGroups || $[4] !== content || $[5] !== isDesignerPage || $[6] !== sprdAccountsContext || $[7] !== subDomain || $[8] !== t || $[9] !== toggleBasket) {
    totalQuantity = getTotalQuantity(cartAndLineItemGroups?.lineItemGroups);
    T1 = Shell.Bar;
    t7 = "desktop";
    if ($[21] !== content) {
      t8 = <Link href="/" className="block">{isProHeaderContent(content) ? <SpreadshirtProLogo height={40} aria-label="Spreadshirt Pro" /> : <SpreadshirtLogo height={30} aria-label="Spreadshirt" />}</Link>;
      $[21] = content;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    if ($[23] !== isDesignerPage) {
      t9 = isDesignerPage ? undefined : <Suspense><SearchWrapper /></Suspense>;
      $[23] = isDesignerPage;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] !== sprdAccountsContext || $[26] !== subDomain) {
      t10 = <UserMenuButton subDomain={subDomain} sprdAccountsContext={sprdAccountsContext} />;
      $[25] = sprdAccountsContext;
      $[26] = subDomain;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <FavoritesPageLink />;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    if ($[29] !== t10) {
      t6 = <Suspense>{t10}{t11}</Suspense>;
      $[29] = t10;
      $[30] = t6;
    } else {
      t6 = $[30];
    }
    T0 = Button;
    t2 = "plain";
    t3 = "relative h-12 w-12 shrink-0";
    t4 = toggleBasket;
    t5 = t("a11y.cart", {
      count: totalQuantity
    });
    $[3] = cartAndLineItemGroups?.lineItemGroups;
    $[4] = content;
    $[5] = isDesignerPage;
    $[6] = sprdAccountsContext;
    $[7] = subDomain;
    $[8] = t;
    $[9] = toggleBasket;
    $[10] = T0;
    $[11] = T1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = totalQuantity;
  } else {
    T0 = $[10];
    T1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
    totalQuantity = $[20];
  }
  let t10;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ShoppingCart className="size-6" />;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  const t11 = totalQuantity > 99 ? "-right-3" : "-right-1";
  const t12 = totalQuantity === 0 ? "hidden" : "";
  let t13;
  if ($[32] !== t11 || $[33] !== t12) {
    t13 = clsx("absolute -top-1 flex h-5 min-w-5 items-center justify-center rounded-l-xl rounded-r-xl bg-brand-green-dark px-1 text-xs text-white", t11, t12);
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== totalQuantity) {
    t14 = totalQuantity > 99 ? <span>99+</span> : <span>{totalQuantity}</span>;
    $[35] = totalQuantity;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t13 || $[38] !== t14) {
    t15 = <span aria-hidden={true} className={t13}>{t14}</span>;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== T0 || $[41] !== isFetching || $[42] !== t15 || $[43] !== t2 || $[44] !== t3 || $[45] !== t4 || $[46] !== t5) {
    t16 = <T0 variant={t2} className={t3} onClick={t4} aria-label={t5} aria-live="off" aria-busy={isFetching}>{t10}{t15}</T0>;
    $[40] = T0;
    $[41] = isFetching;
    $[42] = t15;
    $[43] = t2;
    $[44] = t3;
    $[45] = t4;
    $[46] = t5;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== t16 || $[49] !== t6) {
    t17 = <>{t6}{t16}</>;
    $[48] = t16;
    $[49] = t6;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== t) {
    t18 = label => t("a11y.openNamedMenu", {
      label
    });
    $[51] = t;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== content) {
    t19 = toExternalLinks(content).map(_temp);
    $[53] = content;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== active || $[56] !== items || $[57] !== openOnHover || $[58] !== resetKey || $[59] !== setSecondLevelOpen || $[60] !== setShowOverlay || $[61] !== t18 || $[62] !== t19) {
    t20 = <Shell.DesktopNav items={items} active={active} resetKey={resetKey} openOnHover={openOnHover} linkComponent={HeaderLinkAdapter} openMenuLabel={t18} onOverlayChange={setShowOverlay} onSecondLevelOpenChange={setSecondLevelOpen}>{t19}</Shell.DesktopNav>;
    $[55] = active;
    $[56] = items;
    $[57] = openOnHover;
    $[58] = resetKey;
    $[59] = setSecondLevelOpen;
    $[60] = setShowOverlay;
    $[61] = t18;
    $[62] = t19;
    $[63] = t20;
  } else {
    t20 = $[63];
  }
  let t21;
  if ($[64] !== T1 || $[65] !== t17 || $[66] !== t20 || $[67] !== t7 || $[68] !== t8 || $[69] !== t9) {
    t21 = <T1 variant={t7} logo={t8} search={t9} actions={t17} below={t20} />;
    $[64] = T1;
    $[65] = t17;
    $[66] = t20;
    $[67] = t7;
    $[68] = t8;
    $[69] = t9;
    $[70] = t21;
  } else {
    t21 = $[70];
  }
  return t21;
};
function _temp(item) {
  return <Shell.Link key={item.key} link={item.link} linkComponent={HeaderLinkAdapter} className="flex items-center gap-2 text-base font-normal">{item.label}<Arrow className="size-4 -rotate-45" /></Shell.Link>;
}